import { styled } from "@mui/material";

export const ColumnDateShow = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const ColumnStatus = styled("div")(() => ({
  position: "relative",
  left: "-2px",
  "& > div": {
    width: "fit-content",
  },
}));
